'use client';

import useIsFocusVisible from '@mui/utils/useIsFocusVisible';
export default useIsFocusVisible;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useIsFocusVisible.js
// module id = 264
// module chunks = 22